export default {
    createBoards: 'Create new platform',
    invite: 'Invite',
    chooseBoards: 'Choose platforms',
    saved: 'Saved'
};
